// These need to be imported first for IE to work
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//
import '@cmsgov/ds-medicare-gov/dist/css/index.css';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';


(async () => {
    const clientSideID = process.env.REACT_APP_LD_CLIENT_ID!;
    const LDProvider = await asyncWithLDProvider({
        clientSideID,
        options: {
            baseUrl: 'https://clientsdk.launchdarkly.us',
            eventsUrl: 'https://events.launchdarkly.us',
            streamUrl: 'https://clientstream.launchdarkly.us',
            streaming: false,
        }
    });

    if (window.newrelic && process.env.REACT_APP_GIT_HASH) {
        window.newrelic.addRelease('wds-accounts', process.env.REACT_APP_GIT_HASH);
    }

    ReactDOM.render(
        <LDProvider>
            <BrowserRouter basename="/account">
                <App/>
            </BrowserRouter>
        </LDProvider>,
        document.getElementById('app-root')
    );
})();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
